export const FilterOptions = {
  ALL: { label: "All languages", value: "all" },
  UNKNOWN: { label: "Unidentified languages", value: "unknown" },
};
